import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Polygon } from 'react-google-maps'
import { injectIntl } from 'react-intl'
import { setActiveBarrios } from 'reducers/seaLice/reducer'
import messages from 'components/Apps/SeaLiceMonitor/translate'
import * as COLOR from 'constants/colors'
import BarrioInfo from './BarrioInfo'

class BarrioPolygonList extends Component {
  constructor(props) {
    super(props)
    const {
      barriosList,
      sitesData,
      activeType,
      intl: { formatMessage },
    } = this.props

    this.state = {
      polygonMarkers: this.getMarkersInfo(
        barriosList.toArray(),
        sitesData.toArray(),
        activeType,
        formatMessage(messages[activeType]),
      ),
    }
  }

  shouldComponentUpdate(nextProps) {
    const { barriosList, sitesData, activeType } = this.props

    if (
      sitesData !== nextProps.sitesData ||
      barriosList !== nextProps.barriosList ||
      activeType !== nextProps.activeType
    ) {
      const {
        intl: { formatMessage },
      } = this.props
      this.setState({
        polygonMarkers: this.getMarkersInfo(
          nextProps.barriosList.toArray(),
          nextProps.sitesData.toArray(),
          nextProps.activeType,
          formatMessage(messages[nextProps.activeType]),
        ),
      })

      return false
    }

    return true
  }

  getMarkersInfo = (barriosList, sitesData, activeType, label) => {
    const markers = {}

    if (!barriosList.length || !sitesData.length) return markers

    for (const key in barriosList) {
      if (barriosList.hasOwnProperty(key)) {
        const barrio = barriosList[key]

        if (!barrio.polygon) continue

        markers[barrio.id] = {
          id: barrio.id,
          name: barrio.name,
          polygon: barrio.polygon.outside,
          label,
          value: null,
        }
      }
    }

    for (const key in sitesData) {
      if (sitesData.hasOwnProperty(key)) {
        const site = sitesData[key]

        if (
          !site.neighborhood_id ||
          !markers.hasOwnProperty(site.neighborhood_id)
        )
          continue

        const marker = markers[site.neighborhood_id]
        const weekObj = site.weeks[site.weeks.length - 1]
        marker.value =
          weekObj[activeType] || weekObj[activeType] === 0
            ? marker.value + weekObj[activeType]
            : marker.value
      }
    }

    for (const key in markers) {
      if (markers.hasOwnProperty(key)) {
        const marker = markers[key]
        if (marker.value) {
          marker.value = Math.round(marker.value * 100) / 100
        }
      }
    }

    return markers
  }

  onBarrioClick = (mapObj, barrio) => {
    this.props.setActiveBarrios(
      this.props.activeBarrios === barrio.id ? 0 : barrio.id,
    )
  }

  onInfoBoxClose = () => {
    this.props.setActiveBarrios(0)
  }

  render() {
    const { activeBarrios, hiddenBarrioTooltip } = this.props
    const barriosList = this.props.barriosList.toArray()
    const { polygonMarkers } = this.state
    const activeBarrioInfo = polygonMarkers[activeBarrios]

    return (
      <>
        {barriosList.length &&
          barriosList.map((barrio, key) => {
            if (barrio.polygon !== null) {
              return (
                <Polygon
                  key={key}
                  path={barrio.polygon.outside}
                  onClick={ev => this.onBarrioClick(ev, barrio)}
                  options={{
                    fillColor:
                      polygonMarkers[barrio.id] &&
                      polygonMarkers[barrio.id].value >= 3
                        ? COLOR.DELICATE_PINK
                        : COLOR.HAZY_GRAY,
                    fillOpacity: activeBarrios === barrio.id ? 0.9 : 0.7,
                    strokeColor:
                      activeBarrios === barrio.id
                        ? COLOR.DEEP_ORANGE
                        : COLOR.MAIN_GRAY,
                    strokeOpacity: 0.8,
                    strokeWeight: activeBarrios === barrio.id ? 2 : 1,
                  }}
                />
              )
            }

            return null
          })}
        {!hiddenBarrioTooltip && (
          <BarrioInfo
            barrioInfo={activeBarrioInfo}
            onClose={this.onInfoBoxClose}
          />
        )}
      </>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    barriosList: state.getIn(['seaLice', 'barriosList']),
    activeBarrios: state.getIn(['seaLice', 'activeBarrios']),
    activeType: state.getIn(['seaLice', 'activeType']),
  }),
  {
    setActiveBarrios,
  },
)(injectIntl(BarrioPolygonList))
